export default __webpack_public_path__ + "mytributes/images/this-page-no-longer-exists.svg";